export default __webpack_public_path__ + "static/media/get_a_demo.3938df60.svg";